/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TellerTransactionOutputDto { 
    depositorUserId?: number;
    depositorUserName?: string | null;
    entryTypeId?: number;
    tenantId?: number;
    transactiondate?: string;
    referenceNumber?: string | null;
    accountNumber?: string | null;
    chequeNumber?: string | null;
    receiptNumber?: string | null;
    comment?: string | null;
    paymentTransactionId?: string | null;
    tellerId?: number;
    tellerName?: string | null;
    balance?: number;
    amount?: number;
    transactionId?: string | null;
    transactionModeId?: number | null;
    hasApproved?: boolean;
    approvedByUserId?: number;
    requestId?: number;
    creditUnionName?: string | null;
    tellerAccountNumber?: string | null;
    creditUnionAddress?: string | null;
    registrationNumber?: string | null;
    paymentTransactionMode?: string | null;
    transactionType?: string | null;
    accountName?: string | null;
    isSuccess?: boolean;
    totalAmount?: number;
    chargeAmount?: number;
    serviceFee?: number;
}

